import { IMAGE_GALLERY_BREAKPOINTS } from '../../../utils/constants'
import { getAssetImageUrl } from '../../../utils/asset-url'
import { getOptimizedImageExtension } from '../../../utils/image-extensions'
import {
  HeadTag,
  HeadTagInput,
  MediaWidthPair
} from '../../../utils/prop-types'
import { InitialProductData } from '../common/types'

const createHeadTags = <T extends Record<string, string>>(
  tags: HeadTagInput<T>[]
): HeadTag[] =>
  tags.map(({ tagName, properties }) => ({
    tagName,
    properties
  }))

const generateLinkTags = (
  initialProductData: InitialProductData,
  mediaWidthPairs: MediaWidthPair[]
): HeadTagInput<Record<string, string>>[] => {
  const assetUrl = getAssetImageUrl(initialProductData?.assets?.[0])

  return assetUrl
    ? mediaWidthPairs.map(({ mediaQuery, width }) => ({
        tagName: 'link',
        properties: {
          rel: 'preload',
          as: 'image',
          href: `${getOptimizedImageExtension(assetUrl)}?width=${width}`,
          fetchpriority: 'high',
          media: mediaQuery
        }
      }))
    : []
}

const headTagsConfig = (initialProductData: InitialProductData): HeadTag[] => {
  const linkTags = generateLinkTags(
    initialProductData,
    IMAGE_GALLERY_BREAKPOINTS
  )

  return createHeadTags(linkTags)
}

export default headTagsConfig
